import type {
  TechExplorationAssessment,
  TechExplorationReviewCommentTargetType,
} from '@/types';

export const HYPOTHESIS_TITLE_MAX_LENGTH = 100;
export const HYPOTHESIS_SHORT_SUMMARY_MAX_LENGTH = 500;

export const SOLUTION_TITLE_MAX_LENGTH = 100;
export const SOLUTION_SUMMARY_MAX_LENGTH = 500;

export const REVIEW_COMMENT_TARGET_TYPE = {
  EXPLORATION: 'exploration',
  HYPOTHESIS: 'hypothesis',
  SOLUTION: 'solution',
  COMPARISON_SOLUTION: 'comparison_solution',
  COMPARISON_RESULT: 'comparison_result',
} as const satisfies Record<string, TechExplorationReviewCommentTargetType>;

export const REVIEW_COMMENT_TARGET_TYPES: ReadonlyArray<TechExplorationReviewCommentTargetType> =
  Object.values(REVIEW_COMMENT_TARGET_TYPE);

export const ASSESSMENT_MARK_MAP: Record<TechExplorationAssessment, string> = {
  positive: '○',
  conditional: '△',
  negative: '×',
};

// 要約モジュール内の表で使う assessment ラベル（メイン比較表の ○△× とは別表現）
export const ASSESSMENT_LABEL_MAP: Record<TechExplorationAssessment, string> = {
  positive: '良好',
  conditional: '条件付き',
  negative: '課題あり',
};

// 解決策比較の summary に埋め込まれる引用マーカーパターン [doc_type:id:lang]（例: [research_paper:12345:ja]）
export const COMPARISON_CITATION_PATTERN = /\[([a-z_]+:\d+:[a-z]{2})\]/g;
